.card {
  display: block;
  padding: 32px 36px;
  border-radius: var(--radius-lg);
  background: var(--color-bg-elevated);
  border: 1px solid var(--color-border-default);
  text-decoration: none;
  color: inherit;
  transition: all var(--duration-medium) var(--ease-expo);
}

.card:hover {
  border-color: var(--card-hover-border);
  background: var(--card-hover-bg);
  transform: translateY(-2px);
}

.date {
  font-family: var(--font-body);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--color-text-muted);
  margin-bottom: 12px;
}

.title {
  font-family: var(--font-heading);
  font-weight: 700;
  font-size: 22px;
  color: var(--color-text-primary);
  letter-spacing: -0.02em;
  margin: 0 0 10px;
}

.excerpt {
  font-family: var(--font-body);
  font-size: 14px;
  line-height: 1.6;
  color: var(--color-text-secondary);
  margin: 0 0 16px;
}

.tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.tag {
  padding: 4px 12px;
  border-radius: var(--radius-pill);
  border: 1px solid var(--color-border-input);
  font-family: var(--font-body);
  font-size: 11px;
  font-weight: 500;
  color: var(--color-text-muted);
  letter-spacing: 0.04em;
}

@media (max-width: 768px) {
  .card {
    padding: 20px;
  }

  .title {
    font-size: 19px;
  }
}
